// extracted by mini-css-extract-plugin
export var addButton = "_48-d";
export var bullets = "_48-e";
export var compact = "_48-2";
export var container = "_48-j";
export var extendedWarrantyModal = "_48-f";
export var learn = "_48-l";
export var learnMore = "_48-g";
export var offeringOption = "_48-3";
export var offeringPrice = "_48-8";
export var offeringSubtitle = "_48-7";
export var offeringTitle = "_48-6";
export var offeringsContainer = "_48-0";
export var pdpTilesBackground = "_48-n";
export var plan = "_48-m";
export var regular = "_48-1";
export var remove = "_48-k";
export var seeDetailsIcon = "_48-i";
export var seeDetailsLink = "_48-h";
export var selectedOption = "_48-4";
export var shieldIcon = "_48-b";
export var shieldIconCompact = "_48-c";
export var subtitle = "_48-a";
export var title = "_48-9";
export var unselectedOption = "_48-5";